// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1fmsa","image":"Header_image__2k0fn","name":"Header_name__1WaZx","info":"Header_info__yOQdS","infoRow":"Header_infoRow__3lh6Z"};